import types from "../actions/types";

const initialState = {
  productsInfo: undefined,
  filters: undefined,
  loading: false,
  discountErrorMessage: undefined,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case types.REQUEST_PRODUCTS:
      return {
        ...state,
        loading: true,
      };
    case types.REQUEST_PRODUCTS_FAILED:
      return {
        ...state,
        loading: false,
      };
    case types.RECEIVED_PRODUCTS:
      return {
        ...state,
        productsInfo: action.productsInfo,
        loading: false,
      };
    case types.PRODUCTS_FILTERS_CHANGED:
      return {
        ...state,
        filters: action.filters,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/shop.js